import * as R from 'ramda';

export var changeLayout = function changeLayout(_ref) {
  var dragIndex = _ref.dragIndex,
      hoverIndex = _ref.hoverIndex,
      dragZone = _ref.dragZone,
      dropZone = _ref.dropZone,
      currentLayout = _ref.currentLayout;

  if (R.equals(dragZone, dropZone)) {
    return R.over(R.lensProp(dropZone), R.move(dragIndex, hoverIndex), currentLayout);
  }
  var item = R.pipe(R.prop(dragZone), R.nth(dragIndex))(currentLayout);
  return R.pipe(R.over(R.lensProp(dragZone), R.without([item])), R.over(R.lensProp(dropZone), R.insert(hoverIndex, item)))(currentLayout);
};

export var rejectHiddenElement = R.map(R.reject(function (_ref2) {
  var isHidden = _ref2.isHidden;
  return isHidden;
}));

export var addHiddenElement = function addHiddenElement(layout) {
  return R.mapObjIndexed(function (values, key) {
    return R.pipe(R.prop(key), R.concat(values))(layout);
  });
};

export var getIsOptionalActivated = function getIsOptionalActivated(layout, optionalId) {
  var founded = R.pipe(R.values, R.unnest, R.find(R.equals(optionalId)))(layout);
  return !R.isNil(founded);
};